import { IconArrowRightRegular } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface CrossSellerProductProps {
  count: number;
  onClick: () => void;
}
export const CrossSellerProduct: React.FC<React.PropsWithChildren<CrossSellerProductProps>> = ({ count, onClick }) => {
  return (
    <Container onClick={onClick}>
      <Text>
        이 상품을 판매하는 다른 스토어 <Count>{count}</Count>
      </Text>
      <IconArrowRightRegular size={20} v3Color='gray400' />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  padding: 0 30px 0 16px;
  display: flex;
  align-items: center;
  height: 70px;
  border-top: 8px solid ${vars.v3Color.gray30};

  svg {
    position: absolute;
    right: 10px;
  }
`;

const Text = styled.div`
  margin: 0 4px 0 0;
  font-size: 18px;
  font-weight: 600;
  color: ${vars.color.textStrong};
`;

const Count = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: ${vars.color.textTertiary};
`;
